module.exports = __webpack_public_path__ + "media/notice8.25e87a0d.mp3";